/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerWorkerConfigV3LightlyLoader
 *
 */
// create custom validators for the regexes
export interface DockerWorkerConfigV3LightlyLoader {
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV3LightlyLoader
        * @type int
    * @minimum 1
            
         */
    batchSize?: number;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV3LightlyLoader
        
        
         */
    shuffle?: boolean;
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV3LightlyLoader
        * @type int
    * @minimum -1
            
         */
    numWorkers?: number;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV3LightlyLoader
        
        
         */
    dropLast?: boolean;
}
/**
 * Check if a given object implements the DockerWorkerConfigV3LightlyLoader interface.
 */
export function instanceOfDockerWorkerConfigV3LightlyLoader(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DockerWorkerConfigV3LightlyLoaderTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerWorkerConfigV3LightlyLoader => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyLoader => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyLoader => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyLoader",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyLoader",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerWorkerConfigV3LightlyLoaderTypiaAssertStringify = (input: DockerWorkerConfigV3LightlyLoader): string => {
    return ((input: any): string => { const assert = (input: any): DockerWorkerConfigV3LightlyLoader => {
        const __is = (input: any): input is DockerWorkerConfigV3LightlyLoader => {
            const $io0 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyLoader => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyLoader",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyLoader",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerWorkerConfigV3LightlyLoader): string => {
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.batchSize ? "" : `"batchSize":${undefined !== input.batchSize ? input.batchSize : undefined},`}${undefined === input.shuffle ? "" : `"shuffle":${undefined !== input.shuffle ? input.shuffle : undefined},`}${undefined === input.numWorkers ? "" : `"numWorkers":${undefined !== input.numWorkers ? input.numWorkers : undefined},`}${undefined === input.dropLast ? "" : `"dropLast":${undefined !== input.dropLast ? input.dropLast : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerWorkerConfigV3LightlyLoaderValidatorShape = {
    'batchSize': yup.number().integer().min(1),
    'shuffle': yup.boolean(),
    'numWorkers': yup.number().integer().min(-1),
    'dropLast': yup.boolean(),
};
export const DockerWorkerConfigV3LightlyLoaderValidator = yup.object().shape(DockerWorkerConfigV3LightlyLoaderValidatorShape);
export const DockerWorkerConfigV3LightlyLoaderStringifyShapeProperties: ObjectSchema['properties'] = {
    'batchSize': {
        'type': 'integer',
        'minimum': 1,
    } as unknown as fastJSON.IntegerSchema,
    'shuffle': {
        'type': 'boolean',
    },
    'numWorkers': {
        'type': 'integer',
        'minimum': -1,
    } as unknown as fastJSON.IntegerSchema,
    'dropLast': {
        'type': 'boolean',
    },
};
export const DockerWorkerConfigV3LightlyLoaderStringifyShape: ObjectSchema = {
    title: 'DockerWorkerConfigV3LightlyLoader Stringifier',
    type: 'object',
    properties: {
        ...DockerWorkerConfigV3LightlyLoaderStringifyShapeProperties
    },
    required: [],
};
export const DockerWorkerConfigV3LightlyLoaderStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerConfigV3LightlyLoaderStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerWorkerConfigV3LightlyLoaderStringify: (data: DockerWorkerConfigV3LightlyLoader) => string = DockerWorkerConfigV3LightlyLoaderStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerWorkerConfigV3LightlyLoaderFromJSON(json: any): DockerWorkerConfigV3LightlyLoader {
    return DockerWorkerConfigV3LightlyLoaderFromJSONTyped(json, false);
}
export function DockerWorkerConfigV3LightlyLoaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerConfigV3LightlyLoader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'batchSize': !exists(json, 'batchSize') ? undefined : json['batchSize'],
        'shuffle': !exists(json, 'shuffle') ? undefined : json['shuffle'],
        'numWorkers': !exists(json, 'numWorkers') ? undefined : json['numWorkers'],
        'dropLast': !exists(json, 'dropLast') ? undefined : json['dropLast'],
    };
}
export function DockerWorkerConfigV3LightlyLoaderToJSON(value?: DockerWorkerConfigV3LightlyLoader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'batchSize': value.batchSize,
        'shuffle': value.shuffle,
        'numWorkers': value.numWorkers,
        'dropLast': value.dropLast,
    };
}
